import { render, staticRenderFns } from "./PendingApprovalMobile.vue?vue&type=template&id=0bde3072&scoped=true"
import script from "./PendingApprovalMobile.vue?vue&type=script&lang=js"
export * from "./PendingApprovalMobile.vue?vue&type=script&lang=js"
import style0 from "./PendingApprovalMobile.vue?vue&type=style&index=0&id=0bde3072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde3072",
  null
  
)

export default component.exports